import { render, staticRenderFns } from "./MensagemMercadoDestinoCard.vue?vue&type=template&id=68fe2e97&scoped=true&"
import script from "./MensagemMercadoDestinoCard.vue?vue&type=script&lang=js&"
export * from "./MensagemMercadoDestinoCard.vue?vue&type=script&lang=js&"
import style0 from "./MensagemMercadoDestinoCard.vue?vue&type=style&index=0&id=68fe2e97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe2e97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VForm,VIcon,VSpacer,VTextarea})
